// React
import React from 'react';
// External libs
import classNames from 'classnames';
// Material UI
import { IconButton } from '@material-ui/core';
// Styles
import useStyles from './CustomHeadphonesButton.styles';
// Components
import HeadsetMicIcon from '@material-ui/icons/HeadsetMic';

const CustomHeadphonesButton = ({ classes, height, onClick, width }) => {
  const componentClasses = useStyles();
  return (
    <IconButton
      className={classNames(componentClasses.button, classes.button)}
      aria-label='Back'
      onClick={onClick}
    >
      <HeadsetMicIcon
        className={classNames(componentClasses.icon, classes.icon)}
      />
    </IconButton>
  );
};

CustomHeadphonesButton.defaultProps = {
  classes: {},
};
export default CustomHeadphonesButton;
